import React from 'react'
import PropTypes from 'prop-types'
import fullstory from '../../../utils/constants/fullstory'

const renderTextAreaInputWithFeedback = ({
  input,
  placeholder,
  type,
  label,
  meta,
  maxLength,
  rows,
}) => {
  return (
    <div className="form-group">
      {label && <label>{label}</label>}
      <textarea
        maxLength={maxLength}
        {...input}
        type={type}
        className={`form-control ${fullstory.classNames.textAreaInput}`}
        placeholder={placeholder}
        rows={rows}
      />
      {!meta.active && !meta.pristine && meta.invalid && (
        <h6 className="text-danger small text-justify" style={{ marginTop: '5px' }}>
          {meta.error}
        </h6>
      )}
      <h6 className="text-right small text-info" style={{ marginTop: 8 }}>
        {input.value.length}/{maxLength}
      </h6>
    </div>
  )
}

renderTextAreaInputWithFeedback.propTypes = {
  input: PropTypes.any.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.any,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  rows: PropTypes.number,
}

renderTextAreaInputWithFeedback.defaultProps = {
  type: 'text',
  placeholder: '',
  maxLength: 200,
  rows: 2,
}

export default renderTextAreaInputWithFeedback



// WEBPACK FOOTER //
// ./src/components/ui/forms/renderTextAreaInputWithFeedback.js